var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4zm-4 10H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"}})}
var staticRenderFns = []

export { render, staticRenderFns }